import React, { Component } from "react"
import OmniAural from "omniaural"
import { withPermissions } from "../components/AuthenticationComponent"
import DeviceDetect from "../components/DeviceDetect"
import { PollingManager } from "../managers/PollingManager"
import { Themes } from "../managers/ThemeManager"
import { Constants } from "../Constants"
import { getPrimaryFactorQRData, getUUIDByUserEmail } from "../services"
import BulletList from "./screen-components/BulletList"
import Bullet1 from "../assets/Bullet1.svg"
import Bullet2 from "../assets/Bullet2.svg"
import Bullet3 from "../assets/Bullet3.svg"
import "./RegisterPFA.css"
import { QRCodeComponent } from "../components/QRCodeComponent"
import { Header } from "./screen-components/PageHeader"
import { ContactInfoText } from "../components/ContactInfoText"

class RegisterPFA extends Component {
  constructor() {
    super()
    this.state = {
      qrCodeExpired: false,
      qrCode: null,
      errorMessage: null,
      showQRInMobile: false
    }
    this.cancelStatusPolling = null

    OmniAural.register(this, ["user", "config"])
  }

  componentDidMount() {
    this.getNewQRCode()
  }

  getNewQRCode = async () => {
    this.cancelStatusPolling?.()
    this.setState({ qrCodeExpired: false, qrCode: null })

    let uuid = null

    // UUID here is only required in development
    if (Constants.IS_DEV) {
      const response = await getUUIDByUserEmail(this.state.user?.email_address)
      uuid = response.payload
    }

    getPrimaryFactorQRData(uuid)
      .then((data) => {
        if (Constants.IS_DEV) {
          console.log(data.url)
        }

        this.setState({ qrCode: data.url, qrCodeExpired: false }, () => {
          this.cancelStatusPolling = PollingManager.startPFRegistrationStatusPolling(
            { uid: this.state.user?.uid, uuid: data.uuid },
            () => {
              this.props.history.push({
                pathname: "/registered",
                state: { prevPath: window.location.pathname }
              })
            },
            (e) => {
              this.setState({ qrCodeExpired: true })
            }
          )
        })
      })
      .catch((error) => {
        this.setState({
          errorMessage: "An error occurred generating a QR Code.",
          qrCodeExpired: true
        })
        console.log("Error generating QR Code: ", error)
      })
  }

  createBulletListItems = (strIn) => {
    const arrOut = []
    Object.keys(Themes.currentTheme().strings).forEach((entry) => {
      if (entry.includes(strIn) && Themes.currentTheme().strings[entry].length !== 0) {
        arrOut.push(Themes.currentTheme().strings[entry])
      }
    })
    arrOut.push(
      <span>
        If you received a privacy warning from your browser when navigating to this page, we
        recommend that you{" "}
        <a className="text-link" href="/certs">
          download a DoD certificate
        </a>{" "}
        to your device.
      </span>
    )
    return arrOut
  }

  openMobileConnect = async () => {
    if (this.state.qrCodeExpired || !this.state.qrCode) {
      await this.getNewQRCode()
    }

    window.location.assign(this.state.qrCode)
  }

  renderQRCodeComponent = () => {
    const { qrCode, qrCodeExpired } = this.state
    const qrSize = this.state.config.qr_code_size || Constants.DEFAULT_QR_SIZE
    return (
      <div className="qr-code-container-pfa">
        {qrCodeExpired ? (
          <div className="expired-qr" style={{ height: qrSize, width: qrSize }}>
            <div className="expired-qr-text">
              <h1>QR CODE EXPIRED</h1>
              <h2 id="expired-qr-h2" className="text-link" onClick={this.getNewQRCode}>
                Refresh
              </h2>
            </div>
          </div>
        ) : qrCode !== null ? (
          <QRCodeComponent data={qrCode} size={qrSize} />
        ) : (
          <div
            style={{
              background: Themes.currentTheme().colors.lighterMediumBase,
              height: qrSize,
              width: qrSize
            }}></div>
        )}
        <div className="qr-code-refresh-instructions">
          <p>QR code not working?</p>
          <p className="text-link" onClick={this.getNewQRCode}>
            Refresh code
          </p>
        </div>
      </div>
    )
  }

  render() {
    const images = Themes.currentTheme().images
    const userFirstName = OmniAural.state.user.first_name?.value() || ""
    const userLastName = OmniAural.state.user.last_name?.value() || ""
    const uid = OmniAural.state.user.uid?.value() || ""

    const registeredDevices = (this.state.user.devices || []).filter(
      (device) => device.primary_factor === true || device.second_factor === true
    )
    return (
      <div>
        <Header />
        <img src={images.appHeroImage} className="app-hero-image" alt="app hero" />
        <div className="body-container">
          {!registeredDevices.length && (
            <>
              <div className="body-container-head mobile-hidden">
                <h5 className="bold">{Themes.currentTheme().strings.registration_greeting}</h5>
              </div>
              <div className="body-container-body mobile-hidden">
                <BulletList items={this.createBulletListItems("register_instructions")} />
              </div>
            </>
          )}
          <div className="body-container-register">
            <h3 id="user-status">
              Your Status:{" "}
              {registeredDevices.length ? (
                <span
                  className="text-link"
                  onClick={() => {
                    this.props.history.push({ pathname: "/registered" })
                    this.cancelStatusPolling?.()
                  }}>
                  {registeredDevices.length} registered device(s)
                </span>
              ) : (
                "Not Registered"
              )}
            </h3>
          </div>
          <div className="body-container-get-started">
            <div style={{display: "flex", flexDirection: "column", paddingBottom: "50px"}}>
              <h1 style={{ textTransform: "capitalize", marginBottom: "0px" }}>Welcome, {userFirstName} {userLastName}</h1>
              <p style={{ fontSize: "14px" }}>UID: {uid}</p>
              <h2>Your registered device(s)</h2>
              <p>Need to reinstall the app? Simply deregister first, and then reregister.</p>
            </div>
            <h1>GET STARTED</h1>
            <h3>Registering and setting up your device only takes a minute.</h3>
            <div className="body-container-content">
              <div className="all-instructions-container">
                <div className="one-instruction">
                  <div className="one-instruction-img-container">
                    <img src={Bullet1} alt="bullet point 1" />
                  </div>
                  <div className="instruction-content">
                    <h6 className="instruction-title">Download</h6>
                    <div className="instruction-text">
                      <p>Download the app on your phone or tablet</p>
                      <p className="device-requirements">Requires iOS 13.1 / Android 10 or newer</p>
                    </div>
                    <div className="apple-google-imgs">
                      <DeviceDetect />
                    </div>
                  </div>
                </div>

                <div className="one-instruction">
                  <div className="one-instruction-img-container">
                    <img src={Bullet2} alt="bullet point 2" />
                  </div>
                  <div className="instruction-content">
                    <h6>Register</h6>
                    <div className="mobile-link-container">
                      {this.state.qrCode !== null ? (
                        <button
                          className="full-width-button"
                          type="button"
                          onClick={this.openMobileConnect}>
                          <span>Register on MobileConnect</span>
                        </button>
                      ) : (
                        <div>Loading Link...</div>
                      )}
                    </div>
                    <p>Launch the app and follow the instructions.</p>

                    <span
                      className="text-link desktop-hidden"
                      onClick={() => {
                        this.setState({ showQRInMobile: true })
                      }}>
                      Show QR Code Here
                    </span>
                  </div>
                </div>
                {this.state.showQRInMobile && this.renderQRCodeComponent()}

                <div className="one-instruction" id="bullet-3">
                  <div className="one-instruction-img-container">
                    <img src={Bullet3} alt="bullet point 3" />
                  </div>
                  <div className="instruction-content">
                    <h6>Scan</h6>
                    <label className="scan-qr-title">YOUR UNIQUE QR CODE</label>
                    {this.renderQRCodeComponent()}
                  </div>
                </div>

                <div className="one-instruction">
                  <div className="instruction-content">
                    <br></br>
                    <p>{Themes.currentTheme().strings.login_prompt_text}</p>
                    <br></br>
                    <br></br>
                    <div className="help-contact-and-terms">
                      <p>Issues with registering or authenticating? </p>
                      <ContactInfoText />
                      <br />
                      <p>By registering your device, you are accepting our</p>
                      <p
                        className="text-link"
                        onClick={() => {
                          this.props.history.push({
                            pathname: "/terms"
                          })
                        }}>
                        {`End User License Agreement and Terms & Conditions`}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withPermissions(RegisterPFA, [Constants.PERMISSION_TYPES.AUTHENTICATED])
